var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiPipeVerticalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h2v40H0Z"
})));
export default SvgHaidiPipeVerticalIcon;